export default {
    data() {
        return {
            show_vip_pop_box: false,
        }
    },
    methods: {
        goVipGuide() {
            wx.redirectTo({
                url: '/pages/personal_package/coin_store/main?from=guide'
            })
        },
        showVipPopBox() {
            this.show_vip_pop_box = true
        },
        hideVipPopBox() {
            this.show_vip_pop_box = false
        }
    }
}